import React from 'react';
import SectionTitle from '../../components/SectionTitle';
import SinglePrice from '../../components/Price';

const Price = () => {
  const basicFeatures = [
    {
      id: 1,
      featureIcon: 'flaticon-check-mark',
      featureTitle: 'Medical Specialties',
    },
    {
      id: 2,
      featureIcon: 'flaticon-check-mark',
      featureTitle: 'Consultation',
    },
    {
      id: 3,
      featureIcon: 'flaticon-check-mark',
      featureTitle: 'investigations',
    },
    {
      id: 4,
      featureIcon: 'flaticon-check-mark',
      featureClass: 'inactive',
      featureTitle: 'Medical Treatments',
    },
    {
      id: 5,
      featureIcon: 'flaticon-check-mark',
      featureClass: 'inactive',
      featureTitle: 'An enim nullam tempor',
    },
  ];
  const standardFeatures = [
    {
      id: 1,
      featureIcon: 'flaticon-check-mark',
      featureTitle: 'Medical Specialties',
    },
    {
      id: 2,
      featureIcon: 'flaticon-check-mark',
      featureTitle: 'Consultation',
    },
    {
      id: 3,
      featureIcon: 'flaticon-check-mark',
      featureTitle: 'investigations',
    },
    {
      id: 4,
      featureIcon: 'flaticon-check-mark',
      featureTitle: 'Medical Treatments',
    },
    {
      id: 5,
      featureIcon: 'flaticon-check-mark',
      featureClass: 'inactive',
      featureTitle: 'An enim nullam tempor',
    },
  ];
  const premiumFeatures = [
    {
      id: 1,
      featureIcon: 'flaticon-check-mark',
      featureTitle: 'Medical Specialties',
    },
    {
      id: 2,
      featureIcon: 'flaticon-check-mark',
      featureTitle: 'Consultation',
    },
    {
      id: 3,
      featureIcon: 'flaticon-check-mark',
      featureTitle: 'investigations',
    },
    {
      id: 4,
      featureIcon: 'flaticon-check-mark',
      featureTitle: 'Medical Treatments',
    },
    {
      id: 5,
      featureIcon: 'flaticon-check-mark',
      featureTitle: 'An enim nullam tempor',
    },
  ];

  return (
    <div id="it-price" className="it-price-area fix grey-bg-3 pt-120 pb-90">
      <div className="container">
        <div className="row">
          <div className="col-xl-12">
            <SectionTitle
              itemClass="it-price-title-box text-center mb-65"
              subTitle="Pricing"
              title="Our Best Pricing"
            />
          </div>
        </div>
        <div className="row gx-35">
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".3s"
          >
            <SinglePrice
              itemClass="it-price-item"
              title="Basic Plan"
              value="250"
              description="Health and medical is a encompasses a wide range of topics
                    related to health"
              features={basicFeatures}
            />
          </div>
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <SinglePrice
              itemClass="it-price-item active"
              title="Standard Plan"
              value="550"
              description="Health and medical is a encompasses a wide range of topics
                    related to health"
              features={standardFeatures}
            />
          </div>
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <SinglePrice
              itemClass="it-price-item"
              title="Premium Plan"
              value="999"
              description="Health and medical is a encompasses a wide range of topics
                    related to health"
              features={premiumFeatures}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Price;
